export default "__VITE_ASSET__2hqSTZ0k__"